import { useTranslation } from "react-i18next";
import type { Reservation } from "../../../../api/reservations";
import { ClockIcon } from "../../../../components/restaurant-schema/schemaIcons";
import { formatClock } from "../../logic/dayTime";
import { reservationStartMs } from "../../logic/tableStatus";

/** Жълтото поле „Следваща резервация 19:00 · Николай Георгиев, 2 гости". */
const NextReservationNote = ({ reservation }: { reservation: Reservation }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-start gap-2.5 rounded-[10px] border border-schema-next-edge bg-brand-tint px-3 py-2.5 text-[12.5px] leading-[1.4] text-brand-deep-ink">
      <ClockIcon className="mt-0.5 size-3.5 shrink-0" />
      <span>
        {t("reservations.popover.next")}{" "}
        <span className="font-bold tabular-nums">
          {t("reservations.popover.nextDetails", {
            time: formatClock(reservationStartMs(reservation)),
            guest: reservation.guestName,
            count: reservation.guests,
          })}
        </span>
      </span>
    </div>
  );
};

export default NextReservationNote;
